<div>
  <div class="loader" [hidden]="!loading">
    <div class="progress-line">
      <div class="indeterminate"></div>
    </div>
  </div>

  <div class="app-container" [hidden]="loading">
    <router-outlet></router-outlet>
  </div>
</div>
